import { initializeApp } from "firebase/app";
import { isSupported as isMessagingSupported, getMessaging, onMessage, getToken } from "firebase/messaging";
import { apiConfiguration } from "../api-configuration";
import { WebPushApi } from "../lib-api";
import { Cookie, CookieKeys } from "../util/cookie";

const firebaseConfig = {
  apiKey: "AIzaSyDIua6jhxaL2PP2vwxSl0qrgedtP3lCVcA",
  projectId: "voresmediehus",
  messagingSenderId: "643495767278",
  appId: "1:643495767278:web:ae636c68e22d22669157ff",
};

const setIsDenied = () => {
  Cookie.set(CookieKeys.PushTokenDenied, "1", { expires: 5 });
};

const isDenied = () => {
  return Cookie.get(CookieKeys.PushTokenDenied) == "1";
};

const isSentToServer = () => {
  return Cookie.get(CookieKeys.PushTokenSentToServer) == "1";
};

const setIsSentToServer = () => {
  Cookie.set(CookieKeys.PushTokenSentToServer, "1", {
    expires: 365,
  });
};

(async () => {
  // Initialize Firebase
  if (!await isMessagingSupported()) {
    return;
  }

  const app = initializeApp(firebaseConfig);

  const messaging = getMessaging(app);

  onMessage(messaging, function (payload) {
    const notification = new Notification(payload.notification!.title!, {
      ...payload.notification,
    });

    notification.onclick = () => location.href = payload.fcmOptions!.link!;
  });

  if (!isDenied() && !isSentToServer()) {
    setTimeout(async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          const token = await getToken(messaging, {
            vapidKey:
              "BANS3njttbzorC9pxntr6T3pL86XqlMBUrkJtiMsc065UJxVsiS6XBbbdS_Qe8ORJCpIRHagJsCQCQUOEWeXHaw",
          });
          const api = new WebPushApi(apiConfiguration);
          await api.postWebPushToken({ token });
          setIsSentToServer();
        } else {
          setIsDenied();
        }
      } catch (err) {
        console.error(err);
        //setIsDenied();
      }
    }, 4000);
  }
})();
